import styled from 'styled-components';
import { selectColor } from '@panel/commons/core/theme';

const Container = styled.div`
  height: 52px;
  margin-top: 40px;
  position: relative;
`;

const BoxContain = styled.div`
  width: calc(100vw + 4px);
  position: absolute;
  left: -20px;
  color: ${selectColor('grayDarkLight')};
  background-color: ${selectColor('grayLight')};
  font-family: 'Hind';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 52px;
  text-align: center;
  vertical-align: middle;
`;

export { Container, BoxContain };
